import { lazy } from "react";

const routes = [
  {
    path: "/settings/users",
    element: lazy(() => import("../../pages/Settings/Users")),
  },
];

export default routes;
